import Vue from 'vue';
import VueRouter from 'vue-router';
// Routes
import companyNext, { CompanyOrganizationRoutePermissionTable } from './routes/company_next';
import accountNext from './routes/account_next';
import openApi from './routes/openApi';
import { workspace } from './routes/workspace';
import { productsClients } from './routes/products_clients';
import { products } from './routes/products';
import { recommendationManagement, RecommendationManagementRoutePermissionTable } from './routes/recommendation_management';
import { functionalAudit, patsnapLabRoutePermissionTable } from './routes/functional_audit';
import { routes as packageRoutes } from './routes/packages';
import { routes as permissionRoutes } from './routes/permission';
import systemRoutes, { systemSearchEngineManagementRoutePermissionTable } from './routes/system';
import troubleshootingRoutes, { MailRoutePermissionTable } from './routes/troubleshooting';
import { coreUtility, coreUtilityRoutePermissionTable } from './routes/coreUtility';
import { E_ROUTE_COMMON, faceMenuRouteHook } from './routes/route.types';
import { applyTrial } from './routes/applyTrial';
import { dataProtection } from './routes/data_protection';
import dataAnalysis from './routes/data_analysis';
import { behavior, DashboardRoutePermissionTable } from './routes/behavior';
import { admin } from './routes/admin';
import { pagessection } from './routes/pagessection';
import { ProductDataStatisticsRoutes } from './routes/product_data_statistics';
import { buildMenu, E_Layout, getEnableFirstRoute } from '@/config/navigation/config';
import { operationTool } from './routes/operation_tool';
Vue.use(VueRouter);
const router = new VueRouter({
    // mode: 'history',
    // base: '/next',
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        { path: '/', name: 'root' },
        {
            path: '/login',
            name: E_ROUTE_COMMON.LOGIN,
            component: () => import('@/views/login/Login-v2.vue'),
            meta: {
                allowAnonymous: true,
                layout: 'full',
            },
        },
        ...openApi,
        ...packageRoutes,
        ...companyNext,
        ...accountNext,
        ...workspace,
        ...productsClients,
        ...products,
        ...recommendationManagement,
        ...functionalAudit,
        ...permissionRoutes,
        ...applyTrial,
        ...coreUtility,
        ...systemRoutes,
        ...troubleshootingRoutes,
        ...dataProtection,
        ...dataAnalysis,
        ...behavior,
        ...admin,
        ...ProductDataStatisticsRoutes,
        ...pagessection,
        ...operationTool,
        {
            path: '/error-404',
            name: E_ROUTE_COMMON.ERROR_404,
            component: () => import('@/views/error/Error404.vue'),
            meta: {
                allowAnonymous: true,
            },
        },
        {
            path: '/error-403',
            name: E_ROUTE_COMMON.ERROR_403,
            component: () => import('@/views/error/Error403/Error403.vue'),
            meta: {
                allowAnonymous: true,
            },
        },
        {
            path: '*',
            redirect: 'error-404',
        }
    ],
});
export function configRouter(config) {
    const { router, authService, $P, systemService, miscApi, environment, navgationService, } = config;
    const initRegion = () => {
        if (systemService.Init) {
            return Promise.resolve();
        }
        return miscApi.getInit().then(res => {
            systemService.Init = true;
            if (!environment.region) {
                systemService.Region = res.region;
                // systemService.Region = 'US'
            }
        });
    };
    router.beforeEach(async (to, fromRoute, next) => {
        console.log('Route to:', to.path);
        const meta = to.meta || {};
        if (meta.allowAnonymous) {
            await authService.enablePassport();
            return next();
        }
        await authService.enableUser().then(initRegion);
        if (await faceMenuRouteHook({ to, $P, next }, coreUtilityRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, systemSearchEngineManagementRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, RecommendationManagementRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, patsnapLabRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, MailRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, CompanyOrganizationRoutePermissionTable)) {
            return;
        }
        if (await faceMenuRouteHook({ to, $P, next }, DashboardRoutePermissionTable)) {
            return;
        }
        const enableMenu = buildMenu(E_Layout.horizontal, $P);
        const enableFirstRouteName = getEnableFirstRoute(enableMenu) || 'error-403';
        if (meta.permission && !($P(meta.permission))) {
            return next({
                name: enableFirstRouteName,
            });
        }
        else {
            if (to.path === '/') {
                if (authService.IsInternalUserAdministrator) {
                    await navgationService.goToAdmin();
                    return;
                }
                return next({
                    name: enableFirstRouteName,
                });
            }
            return next();
        }
    });
    // ? For splash screen
    // Remove afterEach hook if you are not using splash screen
    router.afterEach((to, fromRoute) => {
        const appLoading = document.getElementById('loading-bg');
        if (appLoading) {
            appLoading.style.display = 'none';
        }
        window.rvTrack('View BackOffice Page', {
            pageName: to.name,
        });
    });
}
export default router;
